import {
    DEALERUPLOADAGENTFILE_FAILED,
    DEALERUPLOADAGENTFILE_SUCCESS,
    RESET_DEALERUPLOADAGENTFILE,
    LOADING_DEALERUPLOADAGENTFILE,
    NETWORK_ERROR_DEALERUPLOADAGENTFILE

} from '../types/index';
import { dealerServices } from "../../config/axios";

const resetDealerUploadAgentFile = () => {
    return { type: RESET_DEALERUPLOADAGENTFILE };
};

const dealerUploadAgentFile = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_DEALERUPLOADAGENTFILE });
    await dealerServices
        .post("uploadAgentFile", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(dealerUploadAgentFilesuccess(res.data));
                    break;
                default:
                    dispatch(dealerUploadAgentFileFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_DEALERUPLOADAGENTFILE,
                payload: err
            });
        });
};

function dealerUploadAgentFilesuccess(data) {
    return {
        type: DEALERUPLOADAGENTFILE_SUCCESS,
        payload: data
    };
}
function dealerUploadAgentFileFailed(data) {
    return {
        type: DEALERUPLOADAGENTFILE_FAILED,
        payload: data
    };
}

export { resetDealerUploadAgentFile, dealerUploadAgentFile }